import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-577998b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "instruction" }
const _hoisted_3 = { class: "model-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "model-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f44336"} }, "您的手机型号可能无法完美接收云雀消息推送，建议您使用微信值班。 可在电脑端登录云雀工作台后，在 设置->手机值班 中进行绑定操作。", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "manual-page-btns" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("打开设置页面")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("推送测试（10秒后会收到一条消息）")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "推送通知向导",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" 型号: " + _toDisplayString(_ctx.device) + " " + _toDisplayString(_ctx.hostType) + " " + _toDisplayString(_ctx.os) + " ", 1),
          (_ctx.hostType !== _ctx.HostTypes.iOS)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.mobile_type) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_5, _hoisted_7, 512), [
          [_vShow, _ctx.showPreferWechat]
        ]),
        _createElementVNode("p", {
          innerHTML: _ctx.instructionText,
          class: "instruction-text"
        }, null, 8, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_button, {
            type: "primary",
            block: "",
            class: "settings-btn",
            onClick: _ctx.goSettings
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_van_button, {
            type: "primary",
            block: "",
            class: "test-btn",
            onClick: _ctx.testPush
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}